/* eslint-disable react-hooks/exhaustive-deps */
import React, { useReducer } from 'react';
import { FeedReducer, FeedActionContext, FeedStateContext, FeedInitialState } from './FeedState';
import { FeedSync } from './FeedSync';
import { useSubscribedSymbolsContext } from './context/DataFeedSymbolsContext';

export const Feed: React.FC = ({ children }) => {
  const [state, dispatch] = useReducer(FeedReducer, FeedInitialState);
  return (
    <useSubscribedSymbolsContext.Provider>
      <FeedActionContext.Provider value={dispatch}>
        <FeedStateContext.Provider value={state}>
          <FeedSync />
          {children}
        </FeedStateContext.Provider>
      </FeedActionContext.Provider>
    </useSubscribedSymbolsContext.Provider>
  );
};
